
import { Component, Prop, Vue } from 'vue-property-decorator'
import LazyImage from '@/components/LazyImage.vue'

import { Base } from '@/interfaces/Base'
import { ProductMaster } from '@/models/ProductMaster'
import { ProductDetail } from '@/models/ProductDetail'
import { Attribute } from '@/interfaces/Attribute'
import { BaseCharm } from '@/interfaces/BaseCharm'

import strings from '@/assets/strings.json'

@Component({
  components: {
    LazyImage
  }
})
export default class ProductSelector extends Vue {
  @Prop() private base!: Base | BaseCharm;
  @Prop() private isBase!: boolean;
  @Prop({ default: false }) private simple!: boolean;
  @Prop() private onProductClick!: Function;

  private selectedProduct: ProductDetail | null = null
  private selectedColor: Attribute | null = null
  private selectedOtherAttribute: Attribute | null = null

  private generalStrings = strings.Generals

  productMaster?: ProductMaster

  private breakpoint = '';

  get imageSize (): number | null {
    return this.simple ? 130 : null
  }

  get hasOtherAttributes (): boolean {
    return !!this.productMaster &&
      this.productMaster.attributesCount > 1 &&
      !!this.selectedOtherAttribute &&
      this.productMaster.attributesFor(this.selectedOtherAttribute.key, this.selectedColor!.key, this.selectedColor!.id).length > 1
  }

  created () {
    this.productMaster = new ProductMaster(this.base, this.isBase)

    this.selectedProduct = this.productMaster.products[0]
    this.selectedColor = this.selectedProduct.attributes.Colore

    if (this.selectedProduct.otherAttributeKey) {
      this.selectedOtherAttribute = this.selectedProduct.attributes[this.selectedProduct.otherAttributeKey]
    }

    this.breakpoint = this.calcBreakpoint(true)
    window.addEventListener('resize', () => {
      this.breakpoint = this.calcBreakpoint(true)
    })
  }

  onSelectedChange (event: any) {
    for (const attribute of this.productMaster!.attributesFor(this.selectedOtherAttribute!.key, this.selectedColor!.key, this.selectedColor!.id)) {
      if (attribute.id === parseInt(event.target.value)) {
        this.changeSelectedAttribute(attribute)
        return
      }
    }
  }

  changeSelectedAttribute (attribute: Attribute) {
    if (attribute.key === 'Colore') {
      this.selectedColor = attribute
    } else {
      this.selectedOtherAttribute = attribute
    }

    if (this.selectedColor != null) {
      const productDetail = this.productMaster?.productDetailFor(
        this.selectedColor.key,
        this.selectedColor.id,
        this.selectedOtherAttribute?.key,
        this.selectedOtherAttribute?.id
      )
      if (productDetail != null) {
        this.selectedProduct = productDetail
      } else if (attribute.key === 'Colore') {
        const productDetail = this.productMaster?.productDetailFor(
          this.selectedColor.key,
          this.selectedColor.id
        )
        if (productDetail) {
          this.selectedProduct = productDetail
        }
      }
    }
  }

  productClick () {
    this.onProductClick(this.selectedProduct)
  }

  calcBreakpoint (format: boolean) {
    let breakpoint
    if (window.innerWidth < 576) {
      breakpoint = 'xs'
    } else if (window.innerWidth >= 576 && window.innerWidth < 768) {
      breakpoint = 'sm'
    } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
      breakpoint = 'md'
    } else if (window.innerWidth >= 992 && window.innerWidth < 1200) {
      breakpoint = 'lg'
    } else {
      breakpoint = 'xl'
    }
    if (format) {
      if (breakpoint === 'xs' || breakpoint === 'sm' || breakpoint === 'md') {
        breakpoint = 'mobile'
      } else {
        breakpoint = 'desktop'
      }
    }
    return breakpoint
  }
}
